import * as React from 'react';
/**
 *
 * Original name: convert file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=19420%3A0
 *
 */
export const ConvertFileLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M15.982 2.526a2.417 2.417 0 0 1 1.726.718v.001l1.587 1.595.001.001a2.434 2.434 0 0 1 .713 1.729v11.922H7.517v-5.505h1.5v4.005h9.492V6.975h-2.97V4.026H9.05v4.475h-1.5V2.526h8.433Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M12.34 10.025 11.269 8.91l1.082-1.04 2.793 2.905-2.793 2.905-1.082-1.04 1.073-1.115H6.005v8.495h10.01v1.5H4.505V10.017h1.5v.008h6.336Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
